module.exports = __webpack_public_path__ + "assets/img/1731589512664_.pic_hd.c0650139.jpg";